import { render, staticRenderFns } from "./TheRoom.vue?vue&type=template&id=77d3d038"
import script from "./TheRoom.vue?vue&type=script&lang=js"
export * from "./TheRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_webpack@5.108.4_postcss@8.5.19___ejs@3.1.10_lodash@4.18._z5rsh3vccqgauevuorosu7p4fm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports